// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__5d2_x","inner":"Footer_inner__RY4ud","logo":"Footer_logo__By_cG","heading":"Footer_heading__J3P7e","link":"Footer_link__Yh5A4"};